// SZadmin Jobs page constants — aligned to src/utils/szStatus.js (TOKENS.md).
// Status badges render via the shared `jobStatus`/`badgeStyle` helpers + `.sz-badge`.
import { jobStatus, badgeStyle } from "@/utils/szStatus";

// Toolbar status filter pills: All + the 8 statuses shown in the spec.
// `key` matches the backend status enum (or "all"); label comes from szStatus.
export const statusFilters = [
  { key: "all", label: "All" },
  { key: "PENDING_APPROVAL", label: "Pending" },
  { key: "SEEKING_APPLICANTS", label: "Seeking" },
  { key: "OFFER_SENT", label: "Offer Sent" },
  { key: "HIRED", label: "Hired" },
  { key: "PENDING_COMPLETION", label: "Pending Comp" },
  { key: "RELEASE_PAYMENT", label: "Release Pay" },
  { key: "PAID_COMPLETED", label: "Completed" },
  { key: "CANCELLED", label: "Cancelled" },
];

// Kept for any callers that still import it — derives label/colors from szStatus.
export const statusBadgeMap = Object.fromEntries(
  ["PENDING_APPROVAL", "SEEKING_APPLICANTS", "OFFER_SENT", "HIRED", "PARTIALLY_HIRED",
   "PENDING_COMPLETION", "RELEASE_PAYMENT", "PAID_COMPLETED", "CANCELLED"].map((k) => {
    const s = jobStatus(k);
    return [k, { label: s.label, fg: s.fg, bg: s.bg }];
  })
);

// Renders a job status as a `.sz-badge` pill (dot + label) using szStatus colors.
export const getStatusBadge = (status) => {
  const s = jobStatus(status);
  return (
    <span className="sz-badge" style={badgeStyle(s)}>{s.label}</span>
  );
};

export const getPageNumbers = (currentPage, totalPages, maxVisible = 5) => {
  if (totalPages <= maxVisible) return Array.from({ length: totalPages }, (_, i) => i + 1);
  const half = Math.floor(maxVisible / 2);
  let start = currentPage - half;
  let end = currentPage + half;
  if (start < 1) { start = 1; end = maxVisible; }
  if (end > totalPages) { end = totalPages; start = totalPages - maxVisible + 1; }
  return Array.from({ length: end - start + 1 }, (_, i) => start + i);
};

export const formatDate = (dateStr) => {
  if (!dateStr) return "-";
  return new Date(dateStr).toLocaleDateString("en-AU", { day: "2-digit", month: "short" });
};

export const formatCurrency = (amount) => `$${(amount || 0).toLocaleString()}`;

export const revenue = (job) => (job.budget || job.total_amount || 0) * 0.07;
